<div class="container-fluid my-2 px-0">
  <div class="search-container">
    <div class="search-controls">
      <mat-form-field appearance="outline" class="search-type-select">
        <mat-label>Search Type</mat-label>
        <mat-select [(value)]="selectedSearchType" (selectionChange)="onSearchTypeChange()" [disabled]="isLoading">
          <mat-option value="orderNr">
            <mat-icon>receipt</mat-icon>
            <span class="ml-2">{{ 'TRANSACTION.TABLE.ORDER_NUMBER' | transloco }}</span>
          </mat-option>
          <mat-option value="transactionNr">
            <mat-icon>payment</mat-icon>
            <span class="ml-2">{{ 'TRANSACTION.TABLE.TRANSACTION_NUMBER' | transloco }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="search-field">
        <mat-label>{{ getSearchPlaceholder() | transloco }}</mat-label>
        <input matInput
          [(ngModel)]="currentSearchValue"
          [placeholder]="getSearchPlaceholder() | transloco"
          [disabled]="isLoading"
          (keyup.enter)="executeSearch()">
        <mat-icon matSuffix>{{ getSearchIcon() }}</mat-icon>
      </mat-form-field>

      <button mat-raised-button
        color="primary"
        (click)="executeSearch()"
        [disabled]="isLoading || !currentSearchValue?.trim()"
        class="search-button">
        <mat-icon>search</mat-icon>
        Search
      </button>

      <button mat-stroked-button
        (click)="clearSearch()"
        [disabled]="isLoading"
        class="clear-search-button">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </div>

  <div class="filters-container">
    <div class="filters-header" (click)="toggleFilters()">
      <div class="filters-title">
        <mat-icon>filter_list</mat-icon>
        <span>{{ 'TRANSACTION.FILTER.TITLE' | transloco }}</span>
        @if (getActiveFiltersCount() > 0) {
          <mat-chip-set class="filter-count">
            <mat-chip>{{ getActiveFiltersCount() }} active filter(s)</mat-chip>
          </mat-chip-set>
        }
      </div>
      <mat-icon class="expand-icon" [class.expanded]="filtersExpanded">expand_more</mat-icon>
    </div>

    <div class="filters-content" [class.expanded]="filtersExpanded">
      <form [formGroup]="transactionForm">
        <div class="filters-grid">

          <div class="filter-group">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TRANSACTION.FILTER.TRANSACTION_DATE' | transloco }}</mat-label>
              <mat-date-range-input [formGroup]="transactionForm" [rangePicker]="dateRangePicker" [disabled]="isLoading">
                <input matStartDate formControlName="dateFrom" [disabled]="isLoading" [placeholder]="'TRANSACTION.FILTER.DATE_FROM' | transloco">
                <input matEndDate formControlName="dateTo" [disabled]="isLoading" [placeholder]="'TRANSACTION.FILTER.DATE_TO' | transloco">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="filter-group multiple-select">
            <mat-form-field>
              <mat-select [placeholder]="'TRANSACTION.FILTER.PAYMENT_STATUS' | transloco"
                formControlName="paymentStatusFilter" multiple [disabled]="isLoading">
                @for (status of availablePaymentStatuses; track status) {
                  <mat-option [value]="status">
                    {{ status }}
                  </mat-option>
                }
              </mat-select>
              @if (transactionForm.get('paymentStatusFilter')?.value?.length > 0) {
                <mat-hint>
                  {{ transactionForm.get('paymentStatusFilter')?.value?.length }} status(es) selected
                </mat-hint>
              }
            </mat-form-field>
          </div>

          <div class="filter-group multiple-select">
            <mat-form-field>
              <mat-select [placeholder]="'TRANSACTION.FILTER.PAYMENT_TYPE' | transloco"
                formControlName="paymentTypeFilter" multiple [disabled]="isLoading">
                @for (type of availablePaymentTypes; track type) {
                  <mat-option [value]="type">
                    {{ type }}
                  </mat-option>
                }
              </mat-select>
              @if (transactionForm.get('paymentTypeFilter')?.value?.length > 0) {
                <mat-hint>
                  {{ transactionForm.get('paymentTypeFilter')?.value?.length }} type(s) selected
                </mat-hint>
              }
            </mat-form-field>
          </div>

          @if (availableSubOrgs && availableSubOrgs?.length > 0) {
            <div class="filter-group multiple-select">
              <mat-form-field>
                <mat-select [placeholder]="'TRANSACTION.FILTER.SUB_ORG_IDS' | transloco"
                  formControlName="subOrgIdsFilter" multiple [disabled]="isLoading">
                  <mat-option [value]="organization.organizationId">
                    {{ organization.organizationName }}
                  </mat-option>
                  @for (org of availableSubOrgs; track org) {
                    <mat-option [value]="org.id">
                      {{ org.label }}
                    </mat-option>
                  }
                </mat-select>
                @if (transactionForm.get('subOrgIdsFilter')?.value?.length > 0) {
                  <mat-hint>
                    {{ transactionForm.get('subOrgIdsFilter')?.value?.length }} org(s) selected
                  </mat-hint>
                }
              </mat-form-field>
            </div>
          }

        </div>

        <div class="filter-actions">
          <button mat-raised-button color="primary" (click)="applyFilters()" [disabled]="isLoading">
            <mat-icon>search</mat-icon>
            {{ 'TRANSACTION.FILTER.UPDATE' | transloco }}
          </button>
          <button mat-stroked-button (click)="clearFilters()" [disabled]="isLoading">
            <mat-icon>clear</mat-icon>
            {{ 'TRANSACTION.FILTER.CLEAR' | transloco }}
          </button>
        </div>

      </form>
    </div>
  </div>

  <div class="results-section">
    <mat-paginator
      #paginator
      [length]="totalData"
      [pageSizeOptions]="pageSizes"
      showFirstLastButtons
      [disabled]="isLoading">
    </mat-paginator>

    <div class="overflow-auto">
      <table mat-table [dataSource]="dataSource" class="results-table mat-elevation-z2">

        <ng-container matColumnDef="orderNr">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.ORDER_NUMBER' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.orderNr }} </td>
        </ng-container>

        <ng-container matColumnDef="transactionNr">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.TRANSACTION_NUMBER' | transloco }}
          </th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.transactionNr }} </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.AMOUNT' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.amount }} </td>
        </ng-container>

        <ng-container matColumnDef="vatAmount">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.VAT_AMOUNT' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.vatAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="organizationName">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.ORGANIZATION_NAME' | transloco }}
          </th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.organizationName }}</td>
        </ng-container>

        <ng-container matColumnDef="amountIncVat">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.AMOUNT_INC_VAT' | transloco }}
          </th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.amountIncVat }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentStatus">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.PAYMENT_STATUS' | transloco }}
          </th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentStatus }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.PAYMENT_TYPE' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentType }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.PAYMENT_DATE' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentDate | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="debitCreditType">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.CHARGE_TYPE' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.debitCreditType }}</td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef >{{ 'TRANSACTION.TABLE.CREATED' | transloco }}</th>
          <td mat-cell *matCellDef="let transaction"> {{ transaction.created | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let transaction; columns: displayedColumns;" (click)="goToOrder(transaction.orderId)"
          class="clickable-row">
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-data-content">
              <mat-icon>search_off</mat-icon>
              <span>{{ 'TRANSACTION.TABLE.NO_MATCHES' | transloco }}</span>
            </div>
          </td>
        </tr>

      </table>
    </div>
  </div>
</div>
